import { Box, Container, Grid, Typography } from "@material-ui/core";
import { useDefaultCadastroStyles } from "../cadastros/components/default-cadastro-styles";
import { RoadmapBacklogHeader } from "./components/roadmap-backlog-header/roadmap-backlog-header";
import { RoadmapList } from "./components/roadmap-list/roadmap-list";
import { useStyles } from "./roadmap-backlog-styles";
import { RoadmapBacklogSistemas } from "./components/roadmap-backlog-sistemas/roadmap-backlog-sistemas";
import { useEffect, useMemo, useRef, useState } from "react";
import { useLocation } from "react-router-dom";

export const RoadmapBacklogPage = () => {

    const [sistemaSelected, setSistemaSelected] = useState<string>("");
    const containerRef = useRef<HTMLDivElement>(null)

    const cadastroClasses = useDefaultCadastroStyles();
    const classes = useStyles();
    const location = useLocation()


    const isEmVotacao = location.pathname.indexOf('/roadmap-backlog/em-votacao') > -1

    useEffect(() => {
        setTimeout(() => {
            if (containerRef.current) {
                containerRef.current.scrollIntoView({ behavior: "instant" as any, block: "start" });
            }
        }, 500)
    }, [sistemaSelected])

    const textoRoadmap = useMemo(() => (
        <Grid item xs={12}>
            <Box className={classes.descricao}>
                <Typography variant="body2" align="center" className={classes.subtitle}>
                    Ajude-nos a definir as prioridades do nosso roadmap votando nas tarefas que você considera mais importantes.<br />
                </Typography>
                <Typography variant="body2">
                    <ul style={{ marginTop: 0, marginBottom: 8, paddingLeft: 24 }}>
                        <li>- A cada 14 dias, a votação é reiniciada. Fique atento para votar novamente nas ideias que você acredita serem essenciais!</li>
                        <li>- As tarefas mais votadas serão avaliadas com prioridade para o desenvolvimento.</li>
                    </ul>
                </Typography>
                <Typography variant="body2" align="center">
                    Sua participação é fundamental para evoluirmos juntos.<br />
                    <Box component="strong" textAlign="center">Obrigado por colaborar!</Box>
                </Typography>
            </Box>
        </Grid>
    ), [classes.descricao, classes.subtitle])

    return (
        <Grid className={cadastroClasses.root}>
            <Grid className={cadastroClasses.header}>
                <RoadmapBacklogHeader isEmVotacao={isEmVotacao} />
                <RoadmapBacklogSistemas isEmVotacao={isEmVotacao} carregando={false} setSistemaSelected={setSistemaSelected} sistemaSelected={sistemaSelected} />
            </Grid>
            <Grid container className={classes.container}>
                <Container maxWidth="md" ref={containerRef} className={classes.containerComp}>
                    <Grid container className={classes.content}>
                        {textoRoadmap}
                        <RoadmapList
                            sistemaSelected={sistemaSelected}
                        />
                    </Grid>
                </Container>
            </Grid>
            {/* {isEmVotacao && (
                <ButtonFab
                    onClick={handleChamarGerente}
                    icon={<ChamarGerenteIcon tipo="BUTTON_FAB" class={classes.whatsappIcon} />}
                    color="primary"
                    tooltip="Obter mais detalhes"
                />
            )} */}
        </Grid>
    );
}